import { assertAs } from '@alliance/shared/utils'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core'
import { animate, style, transition, trigger } from '@angular/animations'
import { PolymorpheusContent } from '@alliance/shared/polymorpheus'
import { TooltipPosition } from '../tooltip-position-enum'

@Component({
  selector: 'santa-overlay-tooltip',
  templateUrl: './overlay-tooltip.component.html',
  styleUrls: ['./overlay-tooltip.component.tw.css'],
  animations: [trigger('toggleTooltip', [transition(':enter', [style({ opacity: 0 }), animate('0.01s 0.2s ease-in', style({ opacity: 1 }))])])],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayTooltipComponent {
  @Input() public content: PolymorpheusContent | undefined
  @Input() public context: unknown
  @Input() public wrapText: boolean | undefined
  @Input() public tooltipPosition: TooltipPosition = TooltipPosition.top
  @Input() public additionalOffset: number | undefined
  @Input() public customOffsetClass: string | undefined

  public mobileBottomOffset = 0

  public tooltipPositionConfig: Record<TooltipPosition, string> = {
    [TooltipPosition.bottom]: 'tooltip-bottom',
    [TooltipPosition.top]: 'tooltip-top',
    [TooltipPosition.left]: 'tooltip-left',
    [TooltipPosition.right]: 'tooltip-right'
  }

  public constructor(private cdr: ChangeDetectorRef) {}

  public get assertedContext(): object {
    return assertAs<object>(this.context)
  }

  public detectChanges(): void {
    this.cdr.detectChanges()
  }
}
